import "../styles/Jobs.scss";
import { content } from "../data/content";

const Jobs = () => {
  return (
    <section className="jobs">
      <h2 className="jobs__title">Experience</h2>
      <div className="jobs__grid">
        {content.jobs.map((job) => (
          <div key={job.id} id={job.id} className="jobs__card" tabIndex={0}>
            <div className="jobs__card-header">
              <h3>{job.company}</h3>
              <span className="jobs__period">{job.period}</span>
            </div>
            <h4 className="jobs__role">{job.role}</h4>
            {/* <p className="jobs__description">{job.description}</p> */}
            <div className="jobs__technologies">
              {job.technologies.map((tech, i) => (
                <span key={i} className="jobs__tech-tag">
                  {tech}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Jobs;
